<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">Chyba přihlášení</div>
    </div>

    <div class="hypo-dialog-content" [attr.data-testid]="'lockout-dialog-button-close'">
        <p>
            <span>Váš účet je zablokován. </span>
            @if (seconds > 1800) {
                <span>
                    Obraťte se na podporu Hyponamíru <a href="mailto:info@hyponamiru.cz">info&#64;hyponamiru.cz</a>.
                </span>
            }
            @if (seconds <= 1800) {
                <span>
                    Zkuste to znova za {{ seconds | secondsToMinutes }}. Nebo nám napište na
                    <a href="mailto:info@hyponamiru.cz">info&#64;hyponamiru.cz</a>.
                </span>
            }
        </p>
    </div>

    <div class="hypo-dialog-footer mb-4 flex flex-row items-center justify-center">
        <button
            (click)="dialogRef.close()"
            class="btn btn-lg orange info-text-dialog-button"
            [attr.data-testid]="'lockout-dialog-button-close'"
            mat-button
            type="button">
            Zavřít
        </button>
    </div>
</mat-dialog-content>
